<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">


    <b-row v-bind:class="[{ busy: busy }, 'opacity-transition']">
        <pb-spinner v-if="busy"/>
        <b-col>
            <h4>DELIVERY ADDRESS</h4>
            <b-form @input="bubbleUpdate()">
                <b-form-checkbox v-model="addressData.deliveryAddressSameAsBilling"
                                 true-value="true"
                                 false-value="false">Same as Billing Address
                </b-form-checkbox>
                <div v-if="addressData.deliveryAddressSameAsBilling === false">
                    <b-row class="my-2">
                        <b-col>
                            <label for="deliveryAddress_recipient">Recipient:</label>
                            <b-form-input
                                    id="deliveryAddress_recipient"
                                    name="deliveryAddress_recipient"
                                    type="text"
                                    v-model.trim="addressData.deliveryAddress.recipient"
                                    v-validate="'required'"
                                    placeholder="Company or Personal"
                                    :state="validateState('deliveryAddress_recipient')"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <b-form-input
                                    id="deliveryAddress_recipient_secondary"
                                    name="deliveryAddress_recipient_secondary"
                                    type="text"
                                    v-model.trim="addressData.deliveryAddress.recipientSecondary"
                                    placeholder="Additional Recipient Info"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <label for="deliveryAddress_street">Street:</label>
                            <b-form-input
                                    id="deliveryAddress_street"
                                    name="deliveryAddress_street"
                                    type="text"
                                    placeholder="Street and House Nr."
                                    v-model.trim="addressData.deliveryAddress.street"
                                    v-validate="'required'"
                                    :state="validateState('deliveryAddress_street')"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <label for="deliveryAddress_zip">Zip Code:</label>
                            <b-form-input
                                    id="deliveryAddress_zip"
                                    name="deliveryAddress_zip"
                                    type="text"
                                    v-model.trim="addressData.deliveryAddress.zipCode"
                                    v-validate="'required'"
                                    placeholder="Zip Code"
                                    :state="validateState('deliveryAddress_zip')"
                            ></b-form-input>
                        </b-col>
                        <b-col>
                            <label for="deliveryAddress_city">City:</label>
                            <b-form-input
                                    id="deliveryAddress_city"
                                    name="deliveryAddress_city"
                                    type="text"
                                    v-model.trim="addressData.deliveryAddress.city"
                                    v-validate="'required'"
                                    placeholder="City"
                                    :state="validateState('deliveryAddress_city')"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <label for="deliveryAddress_country">Country:</label>
                            <v-select id="deliveryAddressCountrySelect"
                                      :clearable="false"
                                      name="deliveryAddressCountrySelect"
                                      placeholder="Please select..."
                                      v-validate="'required'"
                                      :class="{ 'is-invalid': errors.has('deliveryAddressCountrySelect') }"
                                      v-model="addressData.deliveryAddress.country"
                                      label="name"
                                      :options="countryList">
                            </v-select>
                        </b-col>
                    </b-row>
                </div>

            </b-form>
        </b-col>
    </b-row>
</template>

<script>
    import ShoppingCartApi from "@shared/_api/shoppingCart";

    export default {
        name: 'pb-address',
        props: {
            addressObj: Object
        },
        data() {
            return {
                busy: false,
                addressData: this.addressObj ? this.addressObj : {
                    deliveryAddressSameAsBilling: true,
                    deliveryAddress: {
                        recipient: null,
                        recipientSecondary: null,
                        street: null,
                        zipCode: null,
                        city: null,
                        country: null
                    },
                    selectedAddressType: 'SELECT_ADDRESS'
                },
                countryList: [],
            }
        },
        created() {
            ShoppingCartApi.getCountryList().then((countryList) => {
                this.countryList = countryList;
            }).finally(() => {
                this.busy = false;
            });
        },
        methods: {
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            bubbleUpdate() {
                this.$emit('input', this.addressData);
            }
        },
        watch: {
            addressObj: function (val) {
                this.addressData = val;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>